module.exports = __webpack_public_path__ + "static/media/emotion_depressed.4b6b8219.svg";